import settings from '../../config/settings';
import * as Sentry from '@sentry/browser';
import _ from 'lodash';
import urlJoin from 'url-join';

export function setupClientErrorReporting() {
  if (__PRODCLIENT__ && _.get(settings, 'sentry.publicDSN')) {
    const {sentry} = settings;
    Sentry.init({
      dsn: sentry.publicDSN,
      release: sentry.release,
      environment: sentry.environment,
      whitelistUrls: [/vupulse\.com/]
    });

    const scriptUrl = urlJoin(settings.frontendBaseURL, settings.widget.snippet.scriptUrl);
    window.addEventListener('unhandledrejection', (e) => {
      const stack = _.get(e, 'reason.stack');
      if (stack && stack.indexOf(scriptUrl) >= 0) {
        Sentry.withScope((scope) => {
          scope.setExtra('debug', false);
          Sentry.captureException(e);
        });
      }
    });
  }
}

export function captureException(e) {
  if (__PRODCLIENT__ && _.get(settings, 'sentry.publicDSN')) {
    Sentry.withScope((scope) => {
      scope.setExtra('debug', false);
      Sentry.captureException(e);
    });
  }
}

export function captureMessage(message, level) {
  if (__PRODCLIENT__ && _.get(settings, 'sentry.publicDSN')) {
    Sentry.withScope((scope) => {
      scope.setExtra('debug', false);
      Sentry.captureMessage(message, level);
    });
  }
}
